import React from 'react';
import ThemeLanguageBar from './ThemeLanguageBar';
import ServiceHighlights from './ServiceHighlights';
import Video from './Video';
import LandingPricingCta from './LandingPricingCta';
import LandingFaq from './LandingFaq';

function LandingPage() {
  return (
    <div className="App landing-page-wrap">
      <ThemeLanguageBar />
      <Video />
      <ServiceHighlights />
      <LandingPricingCta />
      <LandingFaq />
    </div>
  );
}

export default LandingPage;
